import React, {useEffect, useState} from 'react';
import {JsonApiClient} from "@drupal-api-client/json-api-client";
import Config from "../../utils/Config";
import {Jsona} from "jsona";

import Moment from 'react-moment';
import Box from "@mui/material/Box";
import {IAttendee, IAddress, IEvent, IPlace, ISchedule, IDateRange, IRichText} from "./Buxliest";
import AttendeesEventListItem from "./AttendeesEventListItem";
import EventOverviewPerTime from "./EventOverviewPerTime";


const client = new JsonApiClient(Config.getDrupalVar('path.baseRoot') + Config.getDrupalVar('path.baseUrl'), {
  serializer: new Jsona()
});

export interface IAttendeesEventListProps {
  mailHash: string;
}

const AttendeesEventList = (props: IAttendeesEventListProps) => {
  const [attendees, setAttendees] = useState<IAttendee[]>([]);
  const [eventDates, setEventDates] = useState<string[]>([]);
  const [submitting, setSubmitting] = useState<boolean>(true);

  const getAttendees = async () => {
    let attendees = await client.getCollection("bux_attendee/bux_attendee", {
      queryString: "include=event,event.schedule,event.schedule.place&filter[mail_hash]="+props.mailHash+"&sort=event.event_date.value",
    }) as any;
    console.log('Attendees:', attendees);
    const eventDates = new Set<string>();
    attendees.forEach((item) => { eventDates.add(item.event.event_date.value)})
    console.log('eventDates:', eventDates);
    const eventDatesArray = [];
    eventDates.forEach((item) => {
      eventDatesArray.push(item);
    });
    setEventDates(eventDatesArray);
    setAttendees(attendees);
    setSubmitting(false);
  };

  useEffect(() => {
    getAttendees();
  }, []);

  const addAttendeeSuccess = () => {
    getAttendees();
  }

  const removeAttendeeSuccess = () => {
    getAttendees();
  }

  return (
    <div className="max-w-7xl max-lg:max-w-4xl mx-auto py-8 px-4 max-w-[800px]">
      <div className="text-3xl font-semibold">Meine Lesungen</div>
      <div className="grid items-start grid-cols-1 md:grid-cols-1  divide-y divide-gray-300">
        {attendees?.filter((attendee) => !attendee.waitlist).map((item, i) =>
          <Box className="pt-4 pb-4 ">
            <AttendeesEventListItem attendee={item} removeSuccessCallback={removeAttendeeSuccess}></AttendeesEventListItem>
          </Box>
        )}
      </div>
      {attendees?.filter((attendee) => !attendee.waitlist).length <= 0 && (
        <Box className="mb-4">Du bist bei noch keiner Lesung eingetragen.</Box>
      )}

      {attendees?.filter((attendee) => attendee.waitlist).length > 0 && (
        <>
      <div className="text-3xl  font-semibold mt-8">Meine Warteliste</div>
      <div className="grid items-start grid-cols-1 md:grid-cols-1 divide-y divide-gray-300">
        {attendees?.filter((attendee) => attendee.waitlist).map((item, i) =>
          <Box className="pt-4 pb-4 ">
            <AttendeesEventListItem attendee={item} removeSuccessCallback={removeAttendeeSuccess}></AttendeesEventListItem>
          </Box>
        )}
      </div>
        </>
    )}
      {!submitting && (
        <EventOverviewPerTime excludeDates={eventDates} registerSuccessCallback={addAttendeeSuccess}
        title={"Was Dich noch interessieren könnte"}></EventOverviewPerTime>
      )}

    </div>
  );

};

export default AttendeesEventList;
